import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet } from 'APIPackage/MainModule/common/apiTools';

import { IViolationLawsuitType } from '../interfaces/IViolationLawsuitType';

export async function fetchViolationLawsuitTypes(): Promise<IViolationLawsuitType[]> {
  return apiGet<IViolationLawsuitType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/violation-lawsuit-types`,
  );
}

interface IFetchViolationLawsuitTypesBySubjectTypeAndSupervisionType {
  subjectTypeId: number;
  supervisionTypeId: number;
}

export async function fetchViolationLawsuitTypesBySubjectTypeAndSupervisionType({
  subjectTypeId,
  supervisionTypeId,
}: IFetchViolationLawsuitTypesBySubjectTypeAndSupervisionType): Promise<IViolationLawsuitType[]> {
  return apiGet<IViolationLawsuitType[]>(
    `${getServiceBaseURL(
      APIServiceEnum.BASE_SERVICE,
    )}/catalogs/violation-lawsuit-types/${subjectTypeId}/${supervisionTypeId}`,
  );
}
